import { render, staticRenderFns } from "./Clamp.vue?vue&type=template&id=a6e919ac&scoped=true"
import script from "./Clamp.vue?vue&type=script&lang=js"
export * from "./Clamp.vue?vue&type=script&lang=js"
import style0 from "./Clamp.vue?vue&type=style&index=0&id=a6e919ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e919ac",
  null
  
)

export default component.exports